import { cn } from "@/lib/utils";

/**
 * A status chip: neutral surface + foreground text (a pair that passes AA in both themes), with a coloured dot that
 * only SUPPORTS the label. Tinted chips (`bg-attention/10 text-attention` and friends) measured 3.86–4.37:1 at this
 * 12px size in one theme or the other (phase-5 browser check), so the colour moved off the text into the dot.
 */
export type ChipTone = "neutral" | "attention" | "primary" | "success";

const DOT: Record<ChipTone, string> = {
  neutral: "bg-muted-foreground",
  attention: "bg-attention",
  primary: "bg-primary",
  success: "bg-success",
};

export function StatusChip({ tone, children, className }: { tone?: ChipTone; children: React.ReactNode; className?: string }) {
  return (
    <span className={cn("bg-muted text-foreground inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium", className)}>
      {tone ? <span aria-hidden="true" className={cn("size-2 shrink-0 rounded-full", DOT[tone])} /> : null}
      {children}
    </span>
  );
}
